export default {
  state: {
    productStockSettingList: null,
    productStockSettingTotalCount: null,
    productStockSettingSingle: null
  },
  mutations: {
    setProductStockSettingList (state, payload) {
      state.productStockSettingList = payload
    },
    setProductStockSettingTotalCount (state, payload) {
      state.productStockSettingTotalCount = payload
    },
    setProductStockSettingSingle (state, payload) {
      state.productStockSettingSingle = payload
    }
  },
  actions: {
    getProductStockSettingList ({commit, dispatch}, {offset, limit}) {
      const url = '/admin/product/stock/setting/list?access_token=' + this.getters.accessToken + '&offset=' + offset + '&limit=' + limit
      dispatch('apiGet', url)
        .then((data) => {
          commit('setProductStockSettingList', data.product_stock_setting_list)
          commit('setProductStockSettingTotalCount', data.total_count)
        })
        .catch((error) => {
          throw error
        })
    },
    getProductStockSettingSingle ({commit, dispatch}, {id}) {
      const url = '/admin/product/stock/setting/' + id + '/single?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setProductStockSettingSingle', data.product_stock_setting)
        })
        .catch((error) => {
          throw error
        })
    },
    deleteProductStockSetting ({commit, dispatch, getters}, {id}) {
      let post = {
        data: {
          id: id
        }
      }

      post.url = '/admin/product/stock/setting/' + id + '/remove?access_token=' + this.getters.accessToken
      dispatch('apiPost', post)
        .then((data) => {
          commit('setProductStockSettingList', getters.productStockSettingList.filter(item => {
            return item.id !== id
          }))
          commit('setSuccess', 'Скрытый остаток удален')
        })
        .catch((error) => {
          throw error
        })
    },
    async createProductStockSetting ({commit, dispatch}, productStockSetting) {
      let post = {
        data: {
          title: productStockSetting.title
        }
      }

      if (typeof productStockSetting.branchIdList !== 'undefined') {
        post.data.branch_id_list = productStockSetting.branchIdList
      }
      if (typeof productStockSetting.productIdList !== 'undefined') {
        post.data.product_sku_id_list = productStockSetting.productIdList
      }

      let returnData = null
      if (productStockSetting.id === null) {
        post.url = '/admin/product/stock/setting/add?access_token=' + this.getters.accessToken
        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Скрытие остатка создано успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      } else {
        post.id = productStockSetting.id
        post.url = '/admin/product/stock/setting/' + productStockSetting.id + '/update?access_token=' + this.getters.accessToken

        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Скрытый остаток изменен успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      }
      return returnData
    }
  },
  getters: {
    productStockSettingList (state) {
      return state.productStockSettingList
    },
    productStockSettingTotalCount (state) {
      return state.productStockSettingTotalCount
    },
    productStockSettingSingle (state) {
      return state.productStockSettingSingle
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/stock.js